import { BaseExportFormProps } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { TikTokPublishFormContent } from './components/TikTokPublishFormContent';

type TikTokPublishFormProps = BaseExportFormProps<
  socialExport.TiktokPublishDto,
  socialExport.TiktokSettingsDto
>;

/**
 * TikTok publish form gated on creator info. Shows loading/error until creator info is loaded,
 * then renders the form with privacy and interaction options driven by creator info (TikTok guidelines).
 */
export function TikTokPublishForm({
  fragment,
  onUpload,
  defaultSettings,
  videoUrl,
  actions,
}: TikTokPublishFormProps) {
  const creatorInfoQuery = socialExport.useGetTikTokCreatorInfo(fragment.stationId, {
    query: { enabled: !!fragment.stationId },
  });

  return (
    <QueryView query={creatorInfoQuery} inline>
      {(creatorInfo) => (
        <TikTokPublishFormContent
          fragment={fragment}
          onUpload={onUpload}
          defaultSettings={defaultSettings}
          videoUrl={videoUrl}
          actions={actions}
          creatorInfo={creatorInfo}
        />
      )}
    </QueryView>
  );
}
